<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <span class="h5">Resumo dos Atendentes</span>
            </b-card-header>
            <b-card-body>
                <app-tabela
                    idTabela="tblResumoAtendentes"
                    :itens="atendentes"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                >
                </app-tabela>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import UsuariosServicos from '@/app/ctrlacesso/usuarios/UsuariosServicos'
import TabelaComponent from '@/shared/components/TabelaComponent.vue'

export default {
    data() {
        return {
            atendentes: [],
            campos: [
                { key: 'nome', label: 'Nome', sortable: true, filterable: true },
                { key: 'qtdConversasAtendendo', label: 'Conversas', sortable: true, filterable: true }
            ],
            itensPorPagina: 10
        }
    },
    components: {
        appTabela: TabelaComponent
    },

    methods: {
        obterAtendentes() {
            this.$store.dispatch('addRequest')
            UsuariosServicos.obterAtendentes().then(response => {
                if (response && response.success && Array.isArray(response.data)) {
                    this.atendentes = response.data
                } else {
                    this.$toast.error(
                        'Erro ao obter atendentes',
                        'ERROR',
                        this.$toastConfig.error
                    )
                }
                this.$store.dispatch('removeRequest')
            })
        },
    },
    created() {
        this.obterAtendentes()
    }
}
</script>